import React from "react";
import { Divider } from '../components/catalyst/divider';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

function TabsProfilFacture({ user }) {
  const hasSubscription = Boolean(user.stripe_abonnement);
  const hasStripeCustomer = Boolean(user.stripe_customer_id);

  //console.log("user dans TabsProfilFacture:", user);


  return (
    <div>
      <h3 className="text-base font-semibold leading-7 text-gray-900 mb-2">
        Votre abonnement
      </h3>

      {/* CAS 1 : Abonnement actif */}
      {hasSubscription && (
        <>
          <div className="bg-green-50 sm:rounded-lg mb-6">
            <div className="p-4">
              <h3 className="text-base font-semibold text-gray-900 flex items-center gap-3">
                <CheckCircleIcon className="h-6 w-6 text-green-600" />
                Abonnement actif
              </h3>

              <p className="m-0 text-lg text-gray-500">
                {user.stripe_abonnement}
              </p>
              <a
        className="mt-4 inline-flex items-center rounded-md bg-indigo-600 px-3.5 py-2 text-sm font-semibold text-white shadow hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        target="_blank"
        rel="noopener noreferrer"
        href={`https://billing.stripe.com/p/login/5kA4iddYV4Ia9Fe000?prefilled_email=${encodeURIComponent(user.email)}`}
      >
        Gérer mon abonnement
      </a>
            </div>
          </div>

          <p className="mt-1 text-sm leading-6 text-gray-500">
            Votre abonnement et vos factures sont gérés par notre partenaire Stripe.
          </p>

          <Divider className="mt-3" />

          {hasStripeCustomer && (
            <a
              className="btn-primary mb-3"
              style={{ width: 'fit-content' }}
              target="_blank"
              rel="noopener noreferrer"
              href={`https://billing.stripe.com/p/login/5kA4iddYV4Ia9Fe000?prefilled_email=${user.email}`}
            >
              Gérer mon abonnement
            </a>
          )}
        </>
      )}



           

      {/* CAS 2 : Pas d’abonnement */}
      {!hasSubscription && (
        <>
          <p className="text-sm leading-6 text-gray-500 mb-6">
            Vous n’avez pas encore d’abonnement.
            <br /> Pour continuer à bénéficier de nos services, veuillez choisir un abonnement ci-dessous :
          </p>

          <div className="grid grid-cols-1 gap-8 lg:grid-cols-2">

            {/* ===== ABONNEMENT MENSUEL ET ANNUEL ===== */}
            <div className="ring-gray-200 rounded-3xl p-8 ring-1 xl:p-10 relative">
          <stripe-pricing-table pricing-table-id="prctbl_1TCfgRBu5KNLzGouLKFyQIK7"
          publishable-key="pk_live_51OpXo5Bu5KNLzGou1u8OUu2RGy7qotXuLHB1fWLLT4b3vm24tvvUKG2QMxQJspEAR55fc5CSYjwE97q3Wo5rtfdH00bWVWLyEL">
          </stripe-pricing-table>
            </div>
          </div>
          <p className="text-sm leading-6 text-gray-500 mt-6">
            Le paiement de votre abonnement est géré par notre partenaire Stripe. Vous pouvez régler en toute sécurité par prélèvement automatique en carte bancaire ou prélèvement SEPA.

          </p>

        </>
      )}
    </div>
  );
}

export default TabsProfilFacture;